/**
 * @generated SignedSource<<a5c664904afb7aa720df5692f74ea8df>>
 * @relayHash 72f0e11f3a3324a5c8d9d9a03df96df2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985

import type { ConcreteRequest } from 'relay-runtime';
export type preloadEditorNodeDataProvidersDataQuery$variables = {
  contentId?: string | null;
  status?: ReadonlyArray<string | null> | null;
};
export type preloadEditorNodeDataProvidersDataQuery$data = {
  readonly singleContent: {
    readonly body: {
      readonly atlas_doc_format: {
        readonly value: string | null;
      } | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type preloadEditorNodeDataProvidersDataQuery = {
  response: preloadEditorNodeDataProvidersDataQuery$data;
  variables: preloadEditorNodeDataProvidersDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "atlas_doc_format",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadEditorNodeDataProvidersDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadEditorNodeDataProvidersDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "72f0e11f3a3324a5c8d9d9a03df96df2",
    "id": "c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985",
    "metadata": {},
    "name": "preloadEditorNodeDataProvidersDataQuery",
    "operationKind": "query",
    "text": "query preloadEditorNodeDataProvidersDataQuery($contentId:ID,$status:[String]){singleContent(id:$contentId,status:$status){id,body{atlas_doc_format{value}}}}"
  }
};
})();

(node as any).hash = "b082e4555a8e2adb34e1cfb641ee98a0";

export default node;
